export default "__VITE_ASSET__DqS5UORm__"